import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { TextParallaxContent } from '../components/ui/text-parallax-content';

const sections = [
  {
    imgUrl:
      'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?q=80&w=2671&auto=format&fit=crop',
    subheading: 'Colaboración',
    heading: 'Creamos juntos.',
    title: 'Nuestra misión',
    body: 'Impulsar el crecimiento de empresas y emprendedores a través de soluciones de marketing digital y diseño que generen valor real y medible. Creemos que cada marca tiene una historia única que merece ser contada de la mejor manera.',
    body2:
      'Trabajamos codo a codo con nuestros clientes para entender sus desafíos y transformarlos en oportunidades de crecimiento.',
  },
  {
    imgUrl:
      'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=1600&fit=crop',
    subheading: 'Visión',
    heading: 'Sin compromisos.',
    title: 'Nuestra visión',
    body: 'Ser la agencia referente en Latinoamérica por nuestra capacidad de combinar creatividad, tecnología y estrategia para transformar la forma en que las marcas se conectan con su audiencia.',
    body2:
      'Cada proyecto es una oportunidad de superar expectativas y construir relaciones duraderas basadas en resultados reales.',
  },
  {
    imgUrl:
      'https://images.unsplash.com/photo-1552664730-d307ca884978?w=1600&fit=crop',
    subheading: 'Innovación',
    heading: 'Siempre adelante.',
    title: '¿Por qué elegirnos?',
    body: 'Fusionamos pensamiento creativo con estrategia de negocio. Cada decisión está respaldada por datos y orientada a generar impacto real. Contamos con un equipo multidisciplinario de expertos en marketing, diseño, desarrollo y comunicación.',
    body2:
      'No hacemos diseño por diseño. Creamos soluciones que destacan y convierten.',
  },
];

export default function About() {
  return (
    <div className="page" style={{ paddingTop: 'var(--nav-height)' }}>
      <div className="bg-white">
        {sections.map(({ imgUrl, subheading, heading, title, body, body2 }) => (
          <TextParallaxContent
            key={heading}
            imgUrl={imgUrl}
            subheading={subheading}
            heading={heading}
          >
            <div className="mx-auto grid max-w-5xl grid-cols-1 gap-8 px-4 pb-24 pt-12 md:grid-cols-12">
              <h2
                className="col-span-1 text-3xl font-bold md:col-span-4"
                style={{ fontFamily: "'Playfair Display', Georgia, serif" }}
              >
                {title}
              </h2>
              <div className="col-span-1 md:col-span-8">
                <p className="mb-4 text-xl text-neutral-600 md:text-2xl">{body}</p>
                <p className="mb-8 text-xl text-neutral-600 md:text-2xl">{body2}</p>
                <Link
                  to="/contacto"
                  className="inline-block w-full rounded bg-neutral-900 px-9 py-4 text-xl text-white transition-colors hover:bg-neutral-700 md:w-fit"
                >
                  Contáctanos <ArrowUpRight className="inline" size={20} />
                </Link>
              </div>
            </div>
          </TextParallaxContent>
        ))}
      </div>
    </div>
  );
}
